import { gql } from '@apollo/client';
import { ALL_MEDIUM_FIELDS } from './fragments';

export const upsertFrequencyManagementSettings = gql`
  ${ALL_MEDIUM_FIELDS}

  mutation UpsertFrequencyManagementSettings($settings: [FrequencyManagementSettingsArgsInput!]!) {
    upsertFrequencyManagementSettings(settings: $settings) {
      success {
        Email {
          ...AllMediumFields
        }
        Push {
          ...AllMediumFields
        }
        SMS {
          ...AllMediumFields
        }
      }
    }
  }
`;
